import React, { useContext } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';

import { AuthContext } from '@context/auth';
import { DayTradingContext } from '@context/daytrading';

import { styMenu, styMenuItem, stySubmenu, stySubmenuItem } from './style';

const menus = [
  { label: 'Beranda', pathname: '/home/' },
  {
    label: 'Cari',
    pathname: '/home/market-index',
    children: [
      {
        label: 'Indeks',
        pathname: '/home/market-index',
      },
      {
        label: 'Saham',
        pathname: '/home/stocks',
      },
      {
        label: 'Reksa Dana',
        pathname: '/home/mutual-funds',
      },
      {
        label: 'Kalender',
        pathname: '/home/calendar',
      },
    ],
  },
  { label: 'Portofolio', pathname: '/home/portofolio' },
  /* {
    label: 'Transaksi',
    pathname: '/home/transaction-stock',
    children: [
      {
        label: 'Saham',
        pathname: '/home/transaction-stock',
      },
      {
        label: 'Day Trading',
        pathname: '/home/transaction-day-trading',
      },
      {
        label: 'Margin Trading',
        pathname: '/home/transaction-margin-trading',
      },
      {
        label: 'Reksa Dana',
        pathname: '/home/transaction-mutual-funds',
      },
      {
        label: 'Auto Order',
        pathname: '/home/transaction-auto-order',
      },
      {
        label: 'Hadiah Saham',
        pathname: '/home/transaction-free-stock',
      },
    ],
  }, */
  { label: 'Berita', pathname: '/home/news' },
];

function TopNavMenu() {
  const location = useLocation();
  const { mtActive } = useContext(AuthContext);
  const { dtActive } = useContext(DayTradingContext);

  const filterTransaksiSubmenuFn = (submenu) => {
    if (!dtActive && submenu.label === 'Day Trading') {
      return false;
    }

    if (!mtActive && submenu.label === 'Margin Trading') {
      return false;
    }

    return true;
  };

  const checkIsActive = ({ pathname, children }) => {
    const match = matchPath(pathname, location.pathname);

    if (match) {
      return true;
    }

    if (Array.isArray(children)) {
      return !!children.find(checkIsActive);
    }

    return false;
  };

  const renderChildren = ({ pathname, label }) => {
    const isActive = checkIsActive({ pathname });

    return (
      <li key={pathname}>
        <Link to={pathname} className={stySubmenuItem({ isActive })}>
          {label}
        </Link>
      </li>
    );
  };

  return (
    <ul className={styMenu}>
      {menus.map(({ label, pathname, children }) => {
        const isActive = checkIsActive({ label, pathname, children });
        const hasChildren = Array.isArray(children);

        if (label === 'Transaksi') {
          // eslint-disable-next-line no-param-reassign
          children = children.filter(filterTransaksiSubmenuFn);
        }

        return (
          <li key={pathname}>
            <Link className={styMenuItem({ isActive })} to={pathname}>
              {label}
            </Link>

            {hasChildren && <ul className={stySubmenu}>{children.map(renderChildren)}</ul>}
          </li>
        );
      })}
    </ul>
  );
}

export default TopNavMenu;
